import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {moduleUiDisplayChanged, moduleUiChanged} from "../../store/configuratorStateSlice";
import ModuleOverviewRow from "./ModuleOverviewRow";

const ModuleOverview = (props) => {
    const dispatch = useDispatch();
    const attributeSelections = useSelector(state => state.productDataReducer.attribute_selections);
    const moduleSelections = useSelector(state => state.productSelectionsReducer.perModuleSelections);
    const sideModules = useSelector(state => state.productDataReducer.side_modules);
    const sideSelections = useSelector(state => state.patternSelectionsReducer.sides);
    const isPattern = useSelector(state => state.configuratorStateReducer.isPattern);

    const toggleUI = (e) => {
        e.preventDefault();
        if(isPattern) {
            dispatch(moduleUiChanged({id: props.side, value: false}))
        } else if(props.isElement){
            dispatch(moduleUiChanged({id: props.elementId, value: false}))
        }else {
            dispatch(moduleUiChanged({id: 'main', value: false}))
        }

    }

    const generateKey = () => {
        return 'overview-' + Math.random();
    }

    const displayModuleRows = () => {
        let rows;
        if(isPattern && props.side) {
            const side = sideSelections.find(side => Object.keys(side)[0] == props.side);
            const moduleAttributes = side[props.side].sidePerModuleAttributes;
            const selections = side[props.side].sidePerModuleSelections;
            rows = moduleAttributes.map(attr => <ModuleOverviewRow attribute={attr} key={generateKey()}
                                                                   selection={selections.filter(sel => sel.selections.includes(attr.module_catalog_key)).length}/>)
        } else {
            const moduleSelections = attributeSelections.filter(sel => sel.per_module);
            rows = moduleSelections.map(sel => <ModuleOverviewRow key={generateKey()} attribute={sel} selection={sel.selection}/>)
        }

        return rows
    }

    let moduleCount;
    let headerStyle= null;
    if( isPattern ){
        const patModules = sideModules.find(sm => Object.keys(sm)[0] == props.side);
        moduleCount = patModules ? patModules[props.side].length : 0;
        headerStyle = {padding: '5px'}
    } else{
        moduleCount = moduleSelections.length
    }
    return (
        <div className="row-config-step">
            <div className="row" style={{margin: 0}}>
                <div className="title small-12 medium-3 columns no-padding" style={{padding: '0'}}>
                    <h3 style={headerStyle}>Module Options</h3>
                    <button onClick={(e) => toggleUI(e)} className="button configurator-action-button" style={{marginTop: '15px'}}>Module details</button>
                </div>
                <div className="small-12 medium-9 columns">
                    <fieldset>
                        <table className="module-option-table module-overview">
                            <tbody>
                                <tr>
                                    <th>Module Quantity</th>
                                    <td>{moduleCount}</td>
                                </tr>
                                { displayModuleRows()}
                            </tbody>
                        </table>
                    </fieldset>
                </div>
            </div>
        </div>
    )
}

export default ModuleOverview;